import React, { useEffect, useRef, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import apiClient from '../../../../services/apiClient';
import "./custom.css";
import UnitOption from "./UnitOption";
import CommonDropdownMenuThree from "../../../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../../../Shared/CommonDropdownMenufour";


function ViewQuestionInfoModal({user,type,id,code,data}) {

  const [pagescontent, setPagescontent] = useState([]);
    const [showsign, setshowsign] = useState(false);

      const [companylogo, setCompanylogo] = useState();
    
      const [phone, setPhone] = useState();
      const [companyemail, setCompanyemail] = useState();
        const [fname, setFname] = useState();
        const [lname, setLname] = useState();
         const [companyname, setcompanyname] = useState();
         const [customername, setcustomername] = useState('');
      const [invoicecode, setinvoicecode] = useState(0); 
      const [purchageorder, setpurchageorder] = useState('');

       const [smartdate, setsmartdate] = useState(false);
        const [smartday, setsmartday] = useState("");
        const [smartmonth, setsmartmonth] = useState(false);
        const [smartyear, setsmartyear] = useState(false);
          const [proposalstabs, setProposalstabs] = useState([]);

        const options = ["Custom Date", 'Smart date'];
  const options_sub = ["Payment is due on a fixed calendar date", 'Payment due date is based on event or invoice date'];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

       const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

      const formattedDate = `${months[currentDate.getMonth()]
    } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

    const [subtotalprice, setsubtotalprice] = useState(0);
    const [showTaxBox, setShowTaxBox] = useState(false);
    const [taxval, settaxval] = useState(0);
    const [discountval, setdiscountval] = useState(0);
     const [showDiscountBox, setShowDiscountBox] = useState(false);
      const [totalprice, settotalprice] = useState(0);

      const [showDueDateBox, setShowDueDateBox] = useState(null);


     const [popup, setpopup] = useState(false);
      const [placeholder2,setplaceholder2] = useState('Type Placeholder here');
      const [addedoptions,setaddedoptions] = useState([{listpotion:'option'},{listpotion:'option'}]);
      const [question, setQuestion] = useState([]);
      const [title2,settitle2] = useState('Type your question here');
        

     
       
        
  
   useEffect(() => {
    
      //  dispatch(setTitle(data.sharedQuestionnaires.title));



      //  setshareduserdetail(data.user);

     settitle2(data.question1);
     setplaceholder2(data.placeholder1);

  const questions=JSON.parse(data.questions);
 
  setQuestion(questions);

   setCompanylogo(user.Main_Logo ? process.env.REACT_APP_BACKEND_URL + user.Main_Logo : null);

          setPhone(user.Phone_Number);
          setCompanyemail(user.Company_Email);
          setFname(user.first_name);
          setLname(user.last_name);
  
     
   
  }, []);

    useEffect(() => {
    
    
    
        var totalprice = 0;
        proposalstabs.map((ptab) => {
    
         
    
    
    
    
    
    
          if (ptab.type == 'invoice') {
    
            //setinvoicepayments(ptab.invoice_payment);
            ptab.invoice_item.map((tab1) => {
              totalprice = parseFloat(totalprice) + parseFloat(tab1.price);
            });
    
            setsubtotalprice(totalprice);
            if (parseInt(ptab.taxper) > 0) {
              totalprice = parseFloat(totalprice) + parseFloat(ptab.taxper * totalprice / 100);
              settaxval(parseFloat(ptab.taxper) * totalprice / 100);
            } else {
              totalprice = parseFloat(totalprice) + parseFloat(ptab.tax);
              settaxval(ptab.tax);
            }
            if (parseInt(ptab.discountper)) {
              totalprice = totalprice - parseInt(ptab.discountper * totalprice / 100);
              setdiscountval(ptab.discountper * totalprice / 100);
            } else {
              totalprice = totalprice - parseInt(ptab.discount);
              setdiscountval(ptab.discount);
            }
            settotalprice(totalprice);
    
          }
        });
    
    
    
        if (proposalstabs.length > 0) {
    
          const proposaltablenght = proposalstabs.length - 1;
    
          var buttonid = '';
    
          if (proposalstabs[proposaltablenght].type == 'contract') {
            buttonid = `ctab0${proposaltablenght}`;
          } else if (proposalstabs[proposaltablenght].type == 'invoice') {
            buttonid = `invoicetab${proposaltablenght}${proposaltablenght}`;
          } else if (proposalstabs[proposaltablenght].type == 'questionnaires') {
            buttonid = `qutab${proposaltablenght}`;
          }
    
    
    
          const activebutton = document.getElementById(buttonid);
          if (activebutton) {
            activebutton.click();
          }
    
        }
    
    
    
        //active.setAttribute("data-scroll", <your_value>)
      }, [proposalstabs]);

  return (
    <div
      className='modal fade'
      id={`exampleModalq${id}${code}`}
      tabIndex='-1'
      aria-labelledby='exampleModalLabel'
      aria-hidden='true'
       style={{ background:'#fffff'}}
    >
      <div
        className='modal-dialog modal-lg modal-dialog-centered'
        role='document'
        style={{ minHeight: "700px" }}
      >
        <div className='modal-content'>
          {/* Modal header */}
          <div className='modal-header bg-primary'>
            <h5 className='modal-title text-white w-100 text-center' style={{ textTransform:'uppercase'}}>
              {type} 
            </h5>
            <button type='button' className='close' data-bs-dismiss='modal'>
              <span aria-hidden='true' className='modal_button'>
                <i className='fas fa-close'></i>
              </span>
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='modal-body py-5 px-4' style={{ background: "#ffffff" }} >
            <div className='row'>


               <div className='customer_details' style={{ textAlign: "left" }}>
                        {/* Customer info */}
                        {companylogo ? (
                          <>
                          {/*   <div className='logo'>
                              <h4>
                                <img src={companylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                              </h4>
                            </div>*/}
                          </>
                        ) : (<>

                        </>)}
                       {/*  <div className='title'>
                          <h4>{companyname}</h4>
                        </div>
                        <div className='item'>
                          <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
                          <span>{phone}</span>
                          <span>{companyemail}</span>

                        </div> */}
                      </div>

             
                <div className="">


    

            

     
             <div >

             
             
             

                                {/*   <div className="formelement">
                                              <label htmlFor='name' className='form-label mt-0'>
                                                  {title2}
                                                </label>
                                                <input
                                                  type='text'
                                                  className='form-control'
                                                  id='name'
                                                  name='name'
                                                  placeholder={placeholder2}
                                                />
                                </div>

                                 */}

                                {question.map((tab,index) => (
                                  <div className='col-12 teet left' key={index}  >
                                        <div className='mb-3 form_input'  >

                                       
                                        

    {tab?.type!='twofields'  && tab?.type!='2ColumnText' && tab?.type!='FullwidthText' && (<> <label htmlFor='name' className='form-label mt-0'>{tab.ques}</label> </>)}

 {tab?.type=='FullwidthText' && (
            <div className='col-md-12 d-flex center'>
                     <div className='col-md-12 centre'>
                                           <label htmlFor='name' className='form-label mt-0'>
                                               {tab.placeholder}
                                           </label>
                                        
                    </div>   
            </div>
             
            ) }


{ tab?.type=='2ColumnText' && (
            <div className='col-md-12 d-flex center'>
                     <div className='col-md-6 margin '>

                                            <label htmlFor='name' className='form-label mt-0'>
                                               {tab.placeholder}
                                           </label>
                                        
                                        
                    </div>
                    <div className='col-md-6 margin'>
                      <div>&nbsp;</div>
                                         <label htmlFor='name' className='form-label mt-0'>
                                               {tab.placeholder2}
                                           </label>
                                        

                                       
                    
                    </div>
            </div>
             
            ) }           

            
{ tab?.type=='twofields' && (
            <div className='col-md-12 d-flex'>
                     <div className='col-md-6 margin left '>

                                           <label htmlFor='name' className='form-label mt-0'>
                                              {tab.ques}
                                           </label>
                                           <div>&nbsp;</div>
                                           <label htmlFor='name' className='form-label mt-0'>
                                              {tab.placeholder}
                                           </label>
                                         
                                        
                    </div>
                    <div className='col-md-6 margin left'>

                                             <label htmlFor='name' className='form-label mt-0'>
                                               {tab.ques2}
                                           </label>
                                           <div>&nbsp;</div>
                                            <label htmlFor='name' className='form-label mt-0'>
                                               {tab.placeholder2}
                                           </label>
                                         

                                       
                    
                    </div>
            </div>
             
            ) }


{tab?.type=='shorttext' && (
            <div className='col-md-12 d-flex '>
                     <div className='col-md-12 left'>

                      <div>&nbsp;</div>
                      <label htmlFor='name' className='form-label mt-0'>
                          {tab.placeholder}
                      </label>
                                        {/*<input
                                          type='text'
                                          className='form-control'
                                          id='name'
                                          name='name'
                                          placeholder=
                                        />*/}
                    </div>   
            </div>
             
            ) }

      {/* long text part start  */}
{ tab?.type=='longtext' && (
            <div className='col-md-12 d-flex left'>
                     <div className='col-md-12 left'>

                      <label htmlFor='name' className='form-label mt-0'>
                          {tab.placeholder !== 'Type your question here' ? tab.placeholder : undefined}
                      </label>
                                           
{/* <textarea   placeholder={tab.placeholder === 'Type your question here' ? "Type your question here" : undefined}
  value=  rows={1} cols="50"   className="textareq"  />*/}

                    </div>
                    
            </div>
             
            ) }

{/* long text part end  */}   

 {/* long text part start  */}
 { tab?.type=='Dropdown' && (
           <> {!tab.optionadd?( <div className='col-md-12 left'> <div className='col-md-12 left'>

                      <select className="selectfull">
                      {tab.option.map((optiontab, index2) => (
                                <option selected={tab.placeholder2 === optiontab.listpotion}>{optiontab.listpotion} </option>
                      ))}
                      </select>
                                   
</div></div> ):('')}    
                    </>
             
            ) }

{/* long text part end  */}   

{/* Single choice part start  */}
{ tab?.type=='Singlechoice' && (
           <><div className='col-md-12 mb-10' >
                               {tab.option.map((optiontab, index2) => (
                                     <div className='col-md-12 gapbetween'>
                                                  <div className='col-md-10'>
                                                  <input type="radio" id={optiontab.listpotion}  name="fav_language" value={optiontab.listpotion} 
                                                  checked={tab.placeholder2?.includes(optiontab.listpotion)} 
                                                  />
                                                    <label for={optiontab.listpotion} >{optiontab.listpotion} </label><br/>
                                                    
                                                   
                                                  </div>
                                               
                                      </div>
                                  ))}
                                                     
             </div>
          </>  
            ) }

{/* Single choice part end  */}   


{/* Multichoice choice part start  */}
{ tab?.type=='Multichoice' && (
             <> <div className='col-md-12 mb-10' >
                                             {tab.option.map((optiontab, index2) => (
                                                         <div className='col-md-12'>
                                                         
                                             <input type="checkbox" id={index2}  name="fav_language" value={optiontab.listpotion}
                                              checked={tab.placeholder2?.includes(optiontab.listpotion)} 
                                             />
                                                       <label for={index2} >{optiontab.listpotion} </label><br/>
                                                          
                                                        
                                                      
                                             </div>
                                                ))}
                                             
                                             
                                           
                                        
                         </div> 
                        </>  
            ) }

{/* Multichoice choice part end  */} 


{/* Multichoice choice part start  */}
{ tab?.type=='DatePicker' && (
            <div className='col-md-12 d-flex left'>
                     <div className='col-md-12'>
                         <input type="date"  className="datetype" value={tab.placeholder2 || ""}/>           
                    </div>    
            </div>
             
            ) }

{/* Multichoice choice part end  */} 

 


                                        </div>
                                  </div>

                                ))}


<div className="gap2">&nbsp;</div>



             </div>

             <div className="gap">&nbsp;</div> 

<div className="nextbtn"> 
                                         
                                         </div> 
      
      </div> 


            </div>
           
           
           
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewQuestionInfoModal;
